import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import MaintenanceDashboardActions from '../dashboards/maintenance/actions';
import MasterOperatorActions from '../master/operators/actions';
import { CONSTANT_VARIABLES } from '../../views/common/Constant_Variables/constants';
import notification from '@tt/components/Notification';

// maintenance Parts
function* fetchMaintenanceParts({ maintenancePartsParams }) {
  try {
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'part/getsearched',
      params: maintenancePartsParams,
    });
    const maintenancePartsData = data;
    yield put(Actions.setMaintenanceParts({ maintenancePartsData }));
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenanceParts({ actionName, maintenancePartsObj, maintenancePartsParams }) {
  try {
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'part',
      data: maintenancePartsObj,
    });
    yield put(Actions.fetchMaintenancePartTypes());
    yield put(Actions.fetchMaintenanceParts({ maintenancePartsParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_PART_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_PART_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteMaintenanceParts({ partId, maintenancePartsParams }) {
  try {
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: true }));
    yield call(api.delete, {
      route: 'part/' + partId,
    });
    yield put(Actions.fetchMaintenancePartTypes());
    yield put(Actions.fetchMaintenanceParts({ maintenancePartsParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_PART_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setMaintenancePartLoader({ maintenancePartsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// maintenance Part Types
function* fetchMaintenancePartTypes() {
  try {
    const { data } = yield call(api.get, {
      route: 'parttype/getparttypes',
    });
    const maintenancePartTypesData = data;
    yield put(Actions.setMaintenancePartTypes({ maintenancePartTypesData }));
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchMaintenancePartTypesSearched({ maintenancePartTypesParams }) {
  try {
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'parttype/getsearched',
      params: maintenancePartTypesParams,
    });
    const maintenancePartTypesSearchedData = data;
    yield put(Actions.setMaintenancePartTypesSearched({ maintenancePartTypesSearchedData }));
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenancePartTypes({ actionName, maintenancePartTypesObj, maintenancePartTypesParams }) {
  try {
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'parttype',
      data: maintenancePartTypesObj,
    });
    yield put(Actions.fetchMaintenancePartTypesSearched({ maintenancePartTypesParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_PART_TYPES_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_PART_TYPES_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteMaintenancePartTypes({ partTypeId, maintenancePartTypesParams }) {
  try {
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: true }));
    yield call(api.delete, {
      route: 'parttype/' + partTypeId,
    });
    yield put(Actions.fetchMaintenancePartTypesSearched({ maintenancePartTypesParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_PART_TYPES_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setMaintenancePartTypesSearchedLoader({ maintenancePartTypesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// Maintenance Types
function* fetchMaintenanceTypesSearched({ maintenanceTypesParams }) {
  try {
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancetype/getsearched',
      params: maintenanceTypesParams,
    });
    const maintenanceTypesSearchedData = data;
    yield put(Actions.setMaintenanceTypesSearched({ maintenanceTypesSearchedData }));
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenanceTypes({ actionName, maintenanceTypesObj, maintenanceTypesParams }) {
  try {
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'maintenancetype',
      data: maintenanceTypesObj,
    });
    yield put(Actions.fetchMaintenanceTypesSearched({ maintenanceTypesParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_TYPES_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_TYPES_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteMaintenanceTypes({ typeId, maintenanceTypesParams }) {
  try {
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: true }));
    yield call(api.delete, {
      route: 'maintenancetype/' + typeId,
    });
    yield put(Actions.fetchMaintenanceTypesSearched({ maintenanceTypesParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_TYPES_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setMaintenanceTypesSearchedLoader({ maintenanceTypesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// maintenance Reason
function* fetchMaintenanceReasonSearched({ maintenanceReasonParams }) {
  try {
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancereason/getsearched',
      params: maintenanceReasonParams,
    });
    const maintenanceReasonSearchedData = data;
    yield put(Actions.setMaintenanceReasonSearched({ maintenanceReasonSearchedData }));
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenanceReason({ actionName, maintenanceReasonObj, maintenanceReasonParams }) {
  try {
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'maintenancereason',
      data: maintenanceReasonObj,
    });
    yield put(Actions.fetchMaintenanceReasonSearched({ maintenanceReasonParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_REASON_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_REASON_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteMaintenanceReason({ reasonId, maintenanceReasonParams }) {
  try {
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: true }));
    yield call(api.delete, {
      route: 'maintenancereason/' + reasonId,
    });
    yield put(Actions.fetchMaintenanceReasonSearched({ maintenanceReasonParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_REASON_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setMaintenanceReasonSearchedLoader({ maintenanceReasonSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// maintenance Status
function* fetchMaintenanceStatusSearched({ maintenanceStatusParams }) {
  try {
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancestatus/getsearched',
      params: maintenanceStatusParams,
    });
    const maintenanceStatusSearchedData = data;
    yield put(Actions.setMaintenanceStatusSearched({ maintenanceStatusSearchedData }));
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenanceStatus({ actionName, maintenanceStatusObj, maintenanceStatusParams }) {
  try {
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'maintenancestatus',
      data: maintenanceStatusObj,
    });
    yield put(Actions.fetchMaintenanceStatusSearched({ maintenanceStatusParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_STATUS_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_STATUS_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteMaintenanceStatus({ statusId, maintenanceStatusParams }) {
  try {
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: true }));
    yield call(api.delete, {
      route: 'maintenancestatus/' + statusId,
    });
    yield put(Actions.fetchMaintenanceStatusSearched({ maintenanceStatusParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_STATUS_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setMaintenanceStatusSearchedLoader({ maintenanceStatusSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// maintenance Job History
function* fetchMaintenanceJobHistoryData({ maintenanceJobHistoryParams }) {
  try {
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancejob/getsearched',
      params: maintenanceJobHistoryParams,
    });
    const maintenanceJobHistoryData = data;
    yield put(Actions.setMaintenanceJobHistoryData({ maintenanceJobHistoryData }));
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}
// export maintenance job history data
function* maintenanceJobHistoryDataExport() {
  try {
    yield put(Actions.maintenanceJobHistoryDataExportLoader({ maintenanceJobHistoryExportLoader: true }));
    const { data } = yield call(api.get, {
      route: 'MaintenanceJob/GetAllCSVData',
    });
    const maintenanceJobHistoryExportData = data;
    yield put(Actions.setMaintenanceJobHistoryDataExport({ maintenanceJobHistoryExportData }));
    yield put(Actions.maintenanceJobHistoryDataExportLoader({ maintenanceJobHistoryExportLoader: false }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchMaintenanceImagesByJob({ jobId }) {
  try {
    yield put(Actions.setMaintenanceImagesByJobLoaderStatus({ maintenanceImageLoader: true }));
    const { data } = yield call(api.get, {
      route: 'maintenancejob/maintenanceimages/' + jobId,
    });
    const maintenanceImagesListData = data;
    yield put(Actions.setMaintenanceImagesByJob({ maintenanceImagesListData }));
    yield put(Actions.setMaintenanceImagesByJobLoaderStatus({ maintenanceImageLoader: false }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
    yield put(Actions.setMaintenanceImagesByJobLoaderStatus({ maintenanceImageLoader: false }));
  }
}

function* addUpdateMaintenanceJobHistory({
  actionName,
  maintenanceJob,
  maintenanceJobHistoryParams,
  maintenanceImages,
}) {
  try {
    const data = { maintenanceJob, maintenanceImage: maintenanceImages };
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: true }));
    if (actionName === CONSTANT_VARIABLES.ADD) {
      yield call(api.post, {
        route: 'maintenancejob/CreateMaintenanceJob',
        data: data,
      });
    }
    if (actionName === CONSTANT_VARIABLES.UPDATE) {
      yield call(api.put, {
        route: 'maintenancejob',
        data: maintenanceJob,
      });
    }
    yield put(MasterOperatorActions.fetchLabours());
    yield put(MaintenanceDashboardActions.fetchMaintenanceJobs());
    yield put(Actions.fetchMaintenanceJobHistoryData({ maintenanceJobHistoryParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_UPDATE,
      ''
    );
  } catch (err) {
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* deleteMaintenanceJobHistory({ maintenanceObj, maintenanceJobHistoryParams }) {
  try {
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: true }));
    yield call(api.delete, {
      route: 'maintenancejob/' + maintenanceObj.id,
    });
    yield put(MasterOperatorActions.fetchLabours());
    yield put(MaintenanceDashboardActions.fetchMaintenanceJobs());
    yield put(Actions.fetchMaintenanceJobHistoryData({ maintenanceJobHistoryParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_JOB_SUCCESS_DELETE, '');
  } catch (err) {
    yield put(Actions.setMaintenanceJobHistoryLoader({ maintenanceJobHistoryLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

// maintenance Recurrence Schedule
function* fetchMaintenanceRecurrenceJobs({ maintenanceRecurrenceJobsParams }) {
  try {
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'recurrencejobs/getsearched',
      params: maintenanceRecurrenceJobsParams,
    });
    const maintenanceRecurrenceJobsData = data;
    yield put(Actions.setMaintenanceRecurrenceJobsData({ maintenanceRecurrenceJobsData }));
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenanceRecurrenceJob({ actionName, recurringMaintenanceObj, maintenanceRecurrenceJobsParams }) {
  try {
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'recurrencejobs',
      data: recurringMaintenanceObj,
    });
    yield put(Actions.fetchMaintenanceRecurrenceJobs({ maintenanceRecurrenceJobsParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_RECURRENCE_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_RECURRENCE_SUCCESS_UPDATE,
      ''
    );
  } catch (err) {
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* deleteMaintenanceRecurrenceJob({ recurringJobId, maintenanceRecurrenceJobsParams }) {
  try {
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: true }));
    yield call(api.delete, {
      route: 'recurrencejobs/' + recurringJobId,
    });
    yield put(Actions.fetchMaintenanceRecurrenceJobs({ maintenanceRecurrenceJobsParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_RECURRENCE_SUCCESS_DELETE, '');
  } catch (err) {
    yield put(Actions.setMaintenanceRecurrenceJobsLoader({ maintenanceRecurrenceJobsLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

// maintenance Recurrence Instance
function* fetchMaintenanceRecurrenceInstances({ recurrenceInstanceParams }) {
  try {
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: true }));
    const { data } = yield call(api.get, {
      route: 'RecurrenceInstances/getsearched',
      params: recurrenceInstanceParams,
    });
    const recurrenceInstanceData = data;
    yield put(Actions.setMaintenanceRecurrenceInstancesData({ recurrenceInstanceData }));
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: false }));
  } catch (error) {
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateMaintenanceRecurrenceInstance({ actionName, recurrenceInstanceObj, recurrenceInstanceParams }) {
  try {
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'RecurrenceInstances',
      data: recurrenceInstanceObj,
    });
    yield put(Actions.fetchMaintenanceRecurrenceInstances({ recurrenceInstanceParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_SUCCESS_ADD
        : CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_SUCCESS_UPDATE,
      ''
    );
  } catch (err) {
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* deleteMaintenanceRecurrenceInstance({ recurringInstanceId, recurrenceInstanceParams }) {
  try {
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: true }));
    yield call(api.delete, {
      route: 'RecurrenceInstances/' + recurringInstanceId,
    });
    yield put(Actions.fetchMaintenanceRecurrenceInstances({ recurrenceInstanceParams }));
    notification('success', CONSTANT_VARIABLES.MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_SUCCESS_DELETE, '');
  } catch (err) {
    yield put(Actions.setMaintenanceRecurrenceInstancesLoader({ recurrenceInstanceLoader: false }));
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_MAINTENANCE_PARTS, fetchMaintenanceParts),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_PARTS, addUpdateMaintenanceParts),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_PARTS, deleteMaintenanceParts),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_PART_TYPES, fetchMaintenancePartTypes),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_PART_TYPES_SEARCHED, fetchMaintenancePartTypesSearched),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_PART_TYPES, addUpdateMaintenancePartTypes),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_PART_TYPES, deleteMaintenancePartTypes),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_TYPES_SEARCHED, fetchMaintenanceTypesSearched),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_TYPES, addUpdateMaintenanceTypes),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_TYPES, deleteMaintenanceTypes),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_REASON_SEARCHED, fetchMaintenanceReasonSearched),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_REASON, addUpdateMaintenanceReason),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_REASON, deleteMaintenanceReason),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_STATUS_SEARCHED, fetchMaintenanceStatusSearched),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_STATUS, addUpdateMaintenanceStatus),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_STATUS, deleteMaintenanceStatus),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_JOB_HISTORY, fetchMaintenanceJobHistoryData),
    takeLatest(ActionTypes.EXPORT_MAINTENANCE_JOB_HISTORY, maintenanceJobHistoryDataExport),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_IMAGES_BY_JOB, fetchMaintenanceImagesByJob),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_JOB_HISTORY, addUpdateMaintenanceJobHistory),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_JOB_HISTORY, deleteMaintenanceJobHistory),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_RECURRENCE_JOBS, fetchMaintenanceRecurrenceJobs),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_RECURRENCE_JOB, addUpdateMaintenanceRecurrenceJob),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_RECURRENCE_JOB, deleteMaintenanceRecurrenceJob),
    takeLatest(ActionTypes.FETCH_MAINTENANCE_RECURRENCE_INSTANCES, fetchMaintenanceRecurrenceInstances),
    takeLatest(ActionTypes.ADD_UPDATE_MAINTENANCE_RECURRENCE_INSTANCE, addUpdateMaintenanceRecurrenceInstance),
    takeLatest(ActionTypes.DELETE_MAINTENANCE_RECURRENCE_INSTANCE, deleteMaintenanceRecurrenceInstance),
  ]);
}
